import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CreateBtn.module.scss';

export const CreateBtn: React.FC = () => {
	return (
		<Link className={style.container} to="/menu-v2/modifiers/create" data-test="CreateBtn">
			<Button
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#plus`} />
					</svg>
				}>
				<Text translationNameSpace="listing" translationKey="addModifierButton" asFragment={true} />
			</Button>
		</Link>
	);
};
